import LegalLayout from "@/layouts/LegalLayout";

export default function RefundsPage() {
  return (
    <LegalLayout title="Refund Policy">
      <p>
        This Refund Policy applies to MinutePay Basic, a SaaS subscription priced at{" "}
        <strong>$9.99 USD per month</strong>.
      </p>

      <h2>1. Recurring subscription</h2>
      <p>
        After a paid subscription starts, it renews monthly until you cancel. Charges are collected
        by Paddle, not as card details stored by MinutePay.
      </p>

      <h2>2. MinutePay’s 7-day trial</h2>
      <p>
        MinutePay offers a <strong>7-day free trial</strong> through Paddle. A payment method is
        required to start the trial. You will not be charged today. After 7 days, Paddle charges
        $9.99/month unless you cancel before renewal. Completing a checkout overlay on the website
        does not itself create access until Paddle confirms the subscription.
      </p>

      <h2>3. Cancellation</h2>
      <p>
        You can cancel a paid subscription to prevent future renewals. Cancel through MinutePay
        Billing and/or the payment provider’s customer tools where available. Cancellation does not
        automatically refund a billing period that has already been completed or paid.
      </p>

      <h2>4. When we will review a refund</h2>
      <p>
        MinutePay does not offer automatic refunds on every cancellation. If you believe you were
        charged incorrectly, billed in error, charged twice, charged after a cancellation that
        should have stopped renewal, or affected by another exceptional billing issue, contact us
        from the email on your MinutePay account and include the date, amount, and payment provider
        if you know it. We will review the request in good faith.
      </p>
      <p>
        Where consumer law requires a refund, or where Paddle requires one, those rules apply in
        addition to this policy.
      </p>

      <h2>5. How to request a review</h2>
      <p>
        Sign in to MinutePay, open Billing, and send the request from the email address on your
        account. MinutePay does not currently publish a separate public support inbox in this
        product.
      </p>
    </LegalLayout>
  );
}
